import { INotificationData } from '../views/notifications/types/notification'
import { HttpClient } from './service'
import Urls from './urls'

export const NotificationApi = {
  getNotifications(queryParams?: Record<string, string>): Promise<INotificationData[]> {
    return HttpClient.get<INotificationData[], Record<string, string>>(Urls.Notification.notification, queryParams)
  },

  updateNotification(employee_id: number, notification_ids: number[]): Promise<number[]> {
    return HttpClient.put<number[], number[]>(Urls.Notification.notification, employee_id, notification_ids)
  },

  deleteNotification(notification: INotificationData): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(Urls.Notification.notification, notification.id)
  },
}
